<ion-list class="flex horizontal-menu" lines="none">
  <div *ngFor="let i of [1, 2, 3]" class="education-and-training-menu">
    <ion-item button mode="ios" detail="false">
      <ion-label>
        <ion-skeleton-text animated style="height: 1.1em; width: 4em;"></ion-skeleton-text>
      </ion-label>
    </ion-item>
  </div>
</ion-list>
